import React from "react";
import { withRouter } from "react-router-dom";
import ExperienceGate from "./ExperienceGate";
import { routeHasDestinationExperienceGate } from "./experienceHelpers";

/**
 * Platform entry ExperienceGate — scoped to application init routes only.
 * Disabled on destinations that resolve their own Experience presentation
 * (Home, browse pages, entities, Film Festival, Social, etc.).
 */
function ExperiencePlatformGate({ presentation, location, children }) {
  const suppress = routeHasDestinationExperienceGate(
    location && location.pathname
  );

  return (
    <ExperienceGate
      destinationType="platform"
      presentation={presentation}
      disabled={suppress}
    >
      {children}
    </ExperienceGate>
  );
}

export default withRouter(ExperiencePlatformGate);
